import { Decision } from './Decision';
import { InputData } from './InputData';
import { BusinessKnowledgeModel } from './BusinessKnowledgeModel';
import { KnowledgeSource } from './KnowledgeSource';
import { DecisionService } from './DecisionService';
import { TextAnnotation } from './TextAnnotation';

export const SHAPES = [
  Decision,
  InputData,
  BusinessKnowledgeModel,
  KnowledgeSource,
  DecisionService,
  TextAnnotation,
];

export const SHAPE_DEFAULTS = {
  'dmn:Decision': { width: 180, height: 80 },
  'dmn:InputData': { width: 125, height: 45 },
  'dmn:BusinessKnowledgeModel': { width: 135, height: 46 },
  'dmn:KnowledgeSource': { width: 100, height: 63 },
  'dmn:DecisionService': { width: 520, height: 260 },
  'dmn:TextAnnotation': { width: 160, height: 40 },
};

export function registerShapes(lf) {
  SHAPES.forEach(({ type, view, model }) => {
    lf.register({ type, view, model });
  });
}
